webpackJsonp([1],{

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(74),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.css.wrapperClass]
  }, [_c('a', {
    class: [_vm.css.linkClass, ( _obj = {}, _obj[_vm.css.disabledClass] = _vm.isOnFirstPage, _obj )],
    on: {
      "click": function($event) {
        _vm.loadPage('prev')
      }
    }
  }, [_c('i', {
    class: _vm.css.icons.prev
  })]), _vm._v(" "), _c('select', {
    class: ['vuetable-pagination-dropdown', _vm.css.dropdownClass],
    on: {
      "change": function($event) {
        _vm.loadPage($event.target.selectedIndex + 1)
      }
    }
  }, _vm._l((_vm.totalPage), function(n) {
    return _c('option', {
      class: [_vm.css.pageClass],
      domProps: {
        "value": n,
        "selected": _vm.isCurrentPage(n)
      }
    }, [_vm._v("\n      " + _vm._s(_vm.pageText) + " " + _vm._s(n) + "\n    ")])
  })), _vm._v(" "), _c('a', {
    class: [_vm.css.linkClass, ( _obj$1 = {}, _obj$1[_vm.css.disabledClass] = _vm.isOnLastPage, _obj$1 )],
    on: {
      "click": function($event) {
        _vm.loadPage('next')
      }
    }
  }, [_c('i', {
    class: _vm.css.icons.next
  })])])
  var _obj;
  var _obj$1;
},staticRenderFns: []}

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFixedHeader) ? _c('div', [_c('div', {
    staticClass: "vuetable-head-wrapper"
  }, [_c('table', {
    class: ['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]
  }, [_c('thead', [_c('tr', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__checkbox') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-checkbox-' + _vm.trackBy, field.titleClass],
      style: ({
        width: field.width
      })
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkCheckboxesState(field.name)
      },
      on: {
        "change": function($event) {
          _vm.toggleAllCheckboxes(field.name, $event)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__component') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-component-' + _vm.trackBy, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__slot') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-slot-' + _vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__sequence') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-sequence', field.titleClass || ''],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot'])) ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass || ''],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e()] : [_c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_' + field.name
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    })]] : _vm._e()]
  }), _vm._v(" "), (_vm.scrollVisible) ? _c('th', {
    staticClass: "vuetable-gutter-col",
    style: ({
      width: _vm.scrollBarWidth
    })
  }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "vuetable-body-wrapper",
    style: ({
      height: _vm.tableHeight
    })
  }, [_c('table', {
    class: ['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]
  }, [_c('colgroup', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [_c('col', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_col_' + field.name
      }
    })] : _vm._e()]
  })], 2), _vm._v(" "), _c('tbody', {
    staticClass: "vuetable-body"
  }, [_vm._l((_vm.tableData), function(item, itemIndex) {
    return [_c('tr', {
      key: itemIndex,
      class: _vm.onRowClass(item, itemIndex),
      attrs: {
        "item-index": itemIndex,
        "render": _vm.onRowChanged(item)
      },
      on: {
        "click": function($event) {
          _vm.onRowClicked(item, $event)
        },
        "dblclick": function($event) {
          _vm.onRowDoubleClicked(item, $event)
        }
      }
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__sequence') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-sequence', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderSequence(itemIndex))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__handle') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-handle', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__checkbox') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-checkboxes', field.dataClass]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowSelected(item, field.name)
        },
        on: {
          "change": function($event) {
            _vm.toggleCheckbox(item, field.name, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__component') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-component', field.dataClass]
      }, [_c(_vm.extractArgs(field.name), {
        tag: "component",
        attrs: {
          "row-data": item,
          "row-index": itemIndex,
          "row-field": field.sortField
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__slot') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-slot', field.dataClass]
      }, [_vm._t(_vm.extractArgs(field.name), null, {
        rowData: item,
        rowIndex: itemIndex,
        rowField: field.sortField
      })], 2) : _vm._e()] : [_c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.renderNormalField(field, item))
        },
        on: {
          "click": function($event) {
            _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            _vm.onCellRightClicked(item, field, $event)
          }
        }
      })]] : _vm._e()]
    })], 2), _vm._v(" "), (_vm.useDetailRow) ? [_c('transition', {
      key: itemIndex,
      attrs: {
        "name": _vm.detailRowTransition
      }
    }, [(_vm.isVisibleDetailRow(item[_vm.trackBy])) ? _c('tr', {
      class: [_vm.css.detailRowClass],
      on: {
        "click": function($event) {
          _vm.onDetailRowClick(item, $event)
        }
      }
    }, [_c('td', {
      attrs: {
        "colspan": _vm.countVisibleFields
      }
    }, [_c(_vm.detailRowComponent, {
      tag: "component",
      attrs: {
        "row-data": item,
        "row-index": itemIndex
      }
    })], 1)]) : _vm._e()])] : _vm._e()]
  }), _vm._v(" "), (_vm.displayEmptyDataRow) ? [_c('tr', [_c('td', {
    staticClass: "vuetable-empty-result",
    attrs: {
      "colspan": _vm.countVisibleFields
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noDataTemplate)
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.lessThanMinRows) ? _vm._l((_vm.blankRows), function(i) {
    return _c('tr', {
      key: i,
      staticClass: "blank-row"
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? _c('td', {
        key: fieldIndex
      }, [_vm._v(" ")]) : _vm._e()]
    })], 2)
  }) : _vm._e()], 2)])])]) : _c('table', {
    class: ['vuetable', _vm.css.tableClass]
  }, [_c('thead', [_c('tr', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__checkbox') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-checkbox-' + _vm.trackBy, field.titleClass],
      style: ({
        width: field.width
      })
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkCheckboxesState(field.name)
      },
      on: {
        "change": function($event) {
          _vm.toggleAllCheckboxes(field.name, $event)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__component') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-component-' + _vm.trackBy, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__slot') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-slot-' + _vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__sequence') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot'])) ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass || '', _vm.sortClass(field)],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e()] : [_c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_' + field.name
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          _vm.orderBy(field, $event)
        }
      }
    })]] : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "vuetable-body"
  }, [_vm._l((_vm.tableData), function(item, itemIndex) {
    return [_c('tr', {
      key: itemIndex,
      class: _vm.onRowClass(item, itemIndex),
      attrs: {
        "item-index": itemIndex,
        "render": _vm.onRowChanged(item)
      },
      on: {
        "dblclick": function($event) {
          _vm.onRowDoubleClicked(item, $event)
        },
        "click": function($event) {
          _vm.onRowClicked(item, $event)
        }
      }
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__sequence') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-sequence', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderSequence(itemIndex))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__handle') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-handle', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__checkbox') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-checkboxes', field.dataClass]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowSelected(item, field.name)
        },
        on: {
          "change": function($event) {
            _vm.toggleCheckbox(item, field.name, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__component') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-component', field.dataClass]
      }, [_c(_vm.extractArgs(field.name), {
        tag: "component",
        attrs: {
          "row-data": item,
          "row-index": itemIndex,
          "row-field": field.sortField
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__slot') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-slot', field.dataClass]
      }, [_vm._t(_vm.extractArgs(field.name), null, {
        rowData: item,
        rowIndex: itemIndex,
        rowField: field.sortField
      })], 2) : _vm._e()] : [(_vm.hasCallback(field)) ? _c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.callCallback(field, item))
        },
        on: {
          "click": function($event) {
            _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            _vm.onCellRightClicked(item, field, $event)
          }
        }
      }) : _c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.getObjectValue(item, field.name, ''))
        },
        on: {
          "click": function($event) {
            _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            _vm.onCellRightClicked(item, field, $event)
          }
        }
      })]] : _vm._e()]
    })], 2), _vm._v(" "), (_vm.useDetailRow) ? [_c('transition', {
      key: itemIndex,
      attrs: {
        "name": _vm.detailRowTransition
      }
    }, [(_vm.isVisibleDetailRow(item[_vm.trackBy])) ? _c('tr', {
      class: [_vm.css.detailRowClass],
      on: {
        "click": function($event) {
          _vm.onDetailRowClick(item, $event)
        }
      }
    }, [_c('td', {
      attrs: {
        "colspan": _vm.countVisibleFields
      }
    }, [_c(_vm.detailRowComponent, {
      tag: "component",
      attrs: {
        "row-data": item,
        "row-index": itemIndex
      }
    })], 1)]) : _vm._e()])] : _vm._e()]
  }), _vm._v(" "), (_vm.displayEmptyDataRow) ? [_c('tr', [_c('td', {
    staticClass: "vuetable-empty-result",
    attrs: {
      "colspan": _vm.countVisibleFields
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noDataTemplate)
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.lessThanMinRows) ? _vm._l((_vm.blankRows), function(i) {
    return _c('tr', {
      key: i,
      staticClass: "blank-row"
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? _c('td', {
        key: fieldIndex
      }, [_vm._v(" ")]) : _vm._e()]
    })], 2)
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tablePagination && _vm.tablePagination.last_page > 1),
      expression: "tablePagination && tablePagination.last_page > 1"
    }],
    class: _vm.css.wrapperClass
  }, [_c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage(1)
      }
    }
  }, [(_vm.css.icons.first != '') ? _c('i', {
    class: [_vm.css.icons.first]
  }) : _c('span', [_vm._v("«")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage('prev')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.prev]
  }) : _c('span', [_vm._v(" ‹")])]), _vm._v(" "), (_vm.notEnoughPages) ? [_vm._l((_vm.totalPage), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(n)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(n)
        }
      }
    })]
  })] : [_vm._l((_vm.windowSize), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart + n - 1) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(_vm.windowStart + n - 1)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(_vm.windowStart + n - 1)
        }
      }
    })]
  })], _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage('next')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.next]
  }) : _c('span', [_vm._v("› ")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage(_vm.totalPage)
      }
    }
  }, [(_vm.css.icons.last != '') ? _c('i', {
    class: [_vm.css.icons.last]
  }) : _c('span', [_vm._v("»")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vuetable-pagination-info', _vm.css.infoClass],
    domProps: {
      "innerHTML": _vm._s(_vm.paginationInfo)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(75),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5cc42bfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(112),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(115),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default.a]
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default.a],
  props: {
    pageText: {
      type: String,
      default: function _default() {
        return 'Page';
      }
    }
  },
  methods: {
    registerEvents: function registerEvents() {
      var self = this;

      this.$on('vuetable:pagination-data', function (tablePagination) {
        self.setPaginationData(tablePagination);
      });
    }
  },
  created: function created() {
    this.registerEvents();
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue___default.a]
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          infoClass: 'left floated left aligned six wide column'
        };
      }
    },
    infoTemplate: {
      type: String,
      default: function _default() {
        return "Displaying {from} to {to} of {total} items";
      }
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No relevant data';
      }
    }
  },
  data: function data() {
    return {
      tablePagination: null
    };
  },
  computed: {
    paginationInfo: function paginationInfo() {
      if (this.tablePagination == null || this.tablePagination.total == 0) {
        return this.noDataTemplate;
      }

      return this.infoTemplate.replace('{from}', this.tablePagination.from || 0).replace('{to}', this.tablePagination.to || 0).replace('{total}', this.tablePagination.total || 0);
    }
  },
  methods: {
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Vuetable_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Vuetable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Vuetable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VuetablePagination_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VuetablePagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VuetablePagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VuetablePaginationDropdown_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VuetablePaginationDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VuetablePaginationDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VuetablePaginationInfo_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VuetablePaginationInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_VuetablePaginationInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







var E_SERVER_ERROR = 'Error communicating with the server';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('custom-actions', {
  template: ['<div>', '<button class="ui red button" @click="onClick(\'view-item\', rowData)"><i class="zoom icon"></i></button>', '<button class="ui blue button" @click="onClick(\'edit-item\', rowData)"><i class="edit icon"></i></button>', '<button class="ui green button" @click="onClick(\'delete-item\', rowData)"><i class="delete icon"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick: function onClick(action, data) {
      console.log('actions: on-click', data.name);
      sweetAlert(action, data.name);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('my-detail-row', {
  template: ['<div @click="onClick">', '<div class="inline field">', '<label>Name: </label>', '<span>{{rowData.name}}</span>', '</div>', '<div class="inline field">', '<label>Email: </label>', '<span>{{rowData.email}}</span>', '</div>', '<div class="inline field">', '<label>Nickname: </label>', '<span>{{rowData.nickname}}</span>', '</div>', '<div class="inline field">', '<label>Birthdate: </label>', '<span>{{rowData.birthdate}}</span>', '</div>', '<div class="inline field">', '<label>Gender: </label>', '<span>{{rowData.gender}}</span>', '</div>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick: function onClick(event) {
      console.log('my-detail-row: on-click', event.target);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('settings-modal', {
  template: '\n    <div class="ui small modal" id="settingsModal">\n      <div class="header">Settings</div>\n      <div class="content ui form">\n        <div class="field">\n          <div class="ui checkbox">\n            <input type="checkbox" v-model="$parent.multiSort">\n            <label>Multisort (use Alt+Click)</label>\n          </div>\n        </div>\n        <div class="inline fields">\n          <div class="field">\n            <div class="ui checkbox">\n              <input type="checkbox" checked="$parent.tableHeight" @change="setTableHeight($event)">\n              <label>Table Height</label>\n            </div>\n          </div>\n          <div class="field">\n            <input type="text" v-model="$parent.tableHeight">\n          </div>\n        </div>\n        <div class="ui divider"></div>\n        <div class="field">\n          <label>Pagination:</label>\n          <select class="ui simple dropdown" v-model="$parent.paginationComponent">\n            <option value="vuetable-pagination">vuetable-pagination</option>\n            <option value="vuetable-pagination-dropdown">vuetable-pagination-dropdown</option>\n          </select>\n        </div>\n        <div class="field">\n          <label>Per Page:</label>\n          <select class="ui simple dropdown" v-model="$parent.perPage">\n            <option :value="10">10</option>\n            <option :value="15">15</option>\n            <option :value="20">20</option>\n            <option :value="25">25</option>\n          </select>\n        </div>\n        <div class="ui fluid card">\n          <div class="content">\n            <div class="header">Visible fields</div>\n          </div>\n          <div v-if="vuetableFields" class="content">\n            <div v-for="(field, idx) in vuetableFields" class="field">\n              <div class="ui checkbox">\n                <input type="checkbox" :checked="field.visible" @change="toggleField(idx, $event)">\n                <label>{{ getFieldTitle(field) }}</label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="actions">\n        <div class="ui cancel button">Close</div>\n      </div>\n    </div>\n  ',
  props: ['vuetableFields'],
  data: function data() {
    return {};
  },

  methods: {
    getFieldTitle: function getFieldTitle(field) {
      if (typeof field.title === 'function') return field.title(true);

      var title = field.title;
      if (title !== '') return this.stripHTML(title);

      title = '';
      if (field.name.slice(0, 2) === '__') {
        title = field.name.indexOf(':') >= 0 ? field.name.split(':')[1] : field.name.replace('__', '');
      }

      return title;
    },
    stripHTML: function stripHTML(str) {
      return str ? str.replace(/(<([^>]+)>)/ig, "") : '';
    },
    toggleField: function toggleField(index, event) {
      console.log('toggleField: ', index, event.target.checked);
      this.$parent.$refs.vuetable.toggleField(index);
    },
    setTableHeight: function setTableHeight(event) {
      if (event.target.checked) {
        this.$parent.tableHeight = '600px';
        return;
      }

      this.$parent.tableHeight = null;
    }
  }
});

var lang = {
  'nickname': 'Nickname',
  'birthdate': 'Birthdate'
};

var tableColumns = [{ name: '__handle',
  width: '50px'
}, {
  name: '__sequence',
  title: 'No.',
  titleClass: 'right aligned',
  dataClass: 'right aligned',
  width: '50px'
}, {
  name: '__checkbox',
  width: '30px',
  title: 'checkbox',
  titleClass: 'center aligned',
  dataClass: 'center aligned'
}, {
  name: 'id',
  title: '<i class="unordered list icon"></i> Detail',
  dataClass: 'center aligned',
  width: '100px',
  callback: 'showDetailRow'

}, {
  name: 'name',
  title: '<i class="book icon"></i> Full Name',
  sortField: 'name',
  width: '150px'
}, {
  name: 'email',
  title: '<i class="mail outline icon"></i> Email',
  sortField: 'email',
  width: '200px',
  dataClass: "vuetable-clip-text",
  visible: true
}, {
  name: 'nickname',
  title: function title() {
    var nameOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return nameOnly ? lang['nickname'] : '<i class="paw icon"></i> ' + lang['nickname'];
  },
  sortField: 'nickname',
  callback: 'allCap',
  width: '120px'
}, {
  name: 'birthdate',
  title: function title() {
    var nameOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return nameOnly ? lang['birthdate'] : '<i class="orange birthday icon"></i> ' + lang['birthdate'];
  },
  sortField: 'birthdate',
  width: '100px',
  callback: 'formatDate|D/MM/Y'
}, {
  name: 'gender',
  title: 'Gender',
  sortField: 'gender',
  titleClass: 'center aligned',
  dataClass: 'center aligned',
  callback: 'gender',
  width: '100px'
}, {
  name: '__component:custom-actions',
  title: 'Actions',
  titleClass: 'center aligned',
  dataClass: 'center aligned',
  width: '150px'
}];

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_1__components_Vuetable_vue___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2__components_VuetablePagination_vue___default.a,
    VuetablePaginationDropdown: __WEBPACK_IMPORTED_MODULE_3__components_VuetablePaginationDropdown_vue___default.a,
    VuetablePaginationInfo: __WEBPACK_IMPORTED_MODULE_4__components_VuetablePaginationInfo_vue___default.a
  },
  data: {
    loading: '',
    searchFor: '',
    moreParams: { aa: 1111, bb: 222 },
    fields: tableColumns,
    tableHeight: '600px',
    vuetableFields: false,
    sortOrder: [{
      field: 'name',
      direction: 'asc'
    }],
    multiSort: true,
    paginationComponent: 'vuetable-pagination',
    perPage: 10,
    paginationInfoTemplate: 'Showing record: {from} to {to} from {total} item(s)',
    lang: lang
  },
  watch: {
    'perPage': function perPage(val, oldVal) {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    'paginationComponent': function paginationComponent(val, oldVal) {
      this.$nextTick(function () {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination);
      });
    }
  },
  methods: {
    transform: function transform(data) {
      var transformed = {};
      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to
      };

      transformed.data = [];
      data = data.data;
      for (var i = 0; i < data.length; i++) {
        transformed['data'].push({
          id: data[i].id,
          name: data[i].name,
          nickname: data[i].nickname,
          email: data[i].email,
          age: data[i].age,
          birthdate: data[i].birthdate,
          gender: data[i].gender,
          address: data[i].address.line1 + ' ' + data[i].address.line2 + ' ' + data[i].address.zipcode
        });
      }

      return transformed;
    },
    showSettingsModal: function showSettingsModal() {
      var self = this;
      $('#settingsModal').modal({
        detachable: true,
        onVisible: function onVisible() {
          $('.ui.checkbox').checkbox();
        }
      }).modal('show');
    },
    showLoader: function showLoader() {
      this.loading = 'loading';
    },
    hideLoader: function hideLoader() {
      this.loading = '';
    },
    allCap: function allCap(value) {
      return value.toUpperCase();
    },
    formatDate: function formatDate(value, fmt) {
      if (value === null) return '';
      fmt = typeof fmt === 'undefined' ? 'D MMM YYYY' : fmt;
      return moment(value, 'YYYY-MM-DD').format(fmt);
    },
    gender: function gender(value) {
      return value === 'M' ? '<span class="ui teal label"><i class="male icon"></i>Male</span>' : '<span class="ui pink label"><i class="female icon"></i>Female</span>';
    },
    showDetailRow: function showDetailRow(value) {
      var icon = this.$refs.vuetable.isVisibleDetailRow(value) ? 'down' : 'right';
      return ['<a class="show-detail-row">', '<i class="chevron circle ' + icon + ' icon"></i>', '</a>'].join('');
    },
    setFilter: function setFilter() {
      this.moreParams['filter'] = this.searchFor;
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    resetFilter: function resetFilter() {
      this.searchFor = '';
      this.setFilter();
    },
    preg_quote: function preg_quote(str) {

      return (str + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight: function highlight(needle, haystack) {
      return haystack.replace(new RegExp('(' + this.preg_quote(needle) + ')', 'ig'), '<span class="highlight">$1</span>');
    },
    rowClassCB: function rowClassCB(data, index) {
      return index % 2 === 0 ? 'odd' : 'even';
    },
    onCellClicked: function onCellClicked(data, field, event) {
      console.log('cellClicked', field.name);
      if (field.name !== '__actions') {
        this.$refs.vuetable.toggleDetailRow(data.id);
      }
    },
    onCellDoubleClicked: function onCellDoubleClicked(data, field, event) {
      console.log('cellDoubleClicked:', field.name);
    },
    onCellRightClicked: function onCellRightClicked(data, field, event) {
      console.log('cellRightClicked:', field.name);
    },
    onLoadSuccess: function onLoadSuccess(response) {
      this.$refs.paginationInfo.setPaginationData(response.data);

      var data = response.data.data;
      if (this.searchFor !== '') {
        for (var n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name);
          data[n].email = this.highlight(this.searchFor, data[n].email);
        }
      }
    },
    onLoadError: function onLoadError(response) {
      if (response.status == 400) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error');
      } else {
        sweetAlert('Oops', E_SERVER_ERROR, 'error');
      }
    },
    onPaginationData: function onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onInitialized: function onInitialized(fields) {
      console.log('onInitialized', fields);
      this.vuetableFields = fields;
    },
    onDataReset: function onDataReset() {
      console.log('onDataReset');
      this.$refs.paginationInfo.resetData();
      this.$refs.pagination.resetData();
    }
  }
});

/***/ })

},[76]);


// WEBPACK FOOTER //
// static/js/app.8a35a4ff3c75994f34dd.js